'use client'

import { Spinner } from '@graftcode/design-system'

import { SHARE_FEEDBACK_TEST_IDS } from '@common/common-test-ids.const'

import styles from './ShareFeedback.module.scss'

export function ShareFeedbackSending() {
  return (
    <div className={styles.sending} data-testid={SHARE_FEEDBACK_TEST_IDS.sending} aria-busy="true" aria-live="polite">
      <Spinner size={48} />
    </div>
  )
}
